import { myCopyright } from './modules/utilities';
import '../sass/main.scss';
import controller from './controller';

function init() {
	myCopyright('Macros by Sara', 'K.J. Roelke', 'kjroelke.online');
}
init();
